const API_BASE = '/api'

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
  if (!res.ok) {
    const err = await res.text()
    throw new Error(err || res.statusText)
  }
  return res.json()
}

export const api = {
  // Auth
  authSetupStatus: () => request<any>('/auth/setup-status'),
  authSetup: (username: string, password: string, display_name: string) =>
    request<any>('/auth/setup', { method: 'POST', body: JSON.stringify({ username, password, display_name }) }),
  authLogin: (username: string, password: string) =>
    request<any>('/auth/login', { method: 'POST', body: JSON.stringify({ username, password }) }),
  authLogout: () => request<any>('/auth/logout', { method: 'POST' }),
  authMe: () => request<any>('/auth/me'),

  // Admin Management
  listAdmins: () => request<any[]>('/admin/users'),
  createAdmin: (data: any) => request('/admin/users', { method: 'POST', body: JSON.stringify(data) }),
  updateAdmin: (id: string, data: any) => request(`/admin/users/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteAdmin: (id: string) => request(`/admin/users/${id}`, { method: 'DELETE' }),

  // Playlists
  getPlaylists: () => request<any[]>('/playlists'),
  getPlaylist: (id: string) => request<any>(`/playlists/${id}`),
  importPlaylist: (url: string) => request<any>('/playlists/import', { method: 'POST', body: JSON.stringify({ url }) }),
  createCollection: (name: string) => request<any>('/playlists/create', { method: 'POST', body: JSON.stringify({ name }) }),

  // Lectures
  getLectures: (courseId?: string) => request<any[]>(`/lectures${courseId ? `?courseId=${courseId}` : ''}`),
  getLecture: (id: string) => request<any>(`/lectures/${id}`),
  createLecture: (data: any) => request('/lectures', { method: 'POST', body: JSON.stringify(data) }),
  bulkCreateLectures: (data: any) => request('/lectures/bulk', { method: 'POST', body: JSON.stringify(data) }),

  // Processing
  fetchTranscript: (lectureId: string) => request(`/process/transcript/${lectureId}`, { method: 'POST' }),
  manufacture: (lectureId: string, types?: string[]) => request(`/process/manufacture/${lectureId}`, {
    method: 'POST', body: JSON.stringify({ types }),
  }),
  generateProduct: (lectureId: string, type: string) => request(`/process/product/${lectureId}`, {
    method: 'POST', body: JSON.stringify({ type }),
  }),
  retryProcess: (lectureId: string, types: string[]) => request(`/process/retry/${lectureId}`, {
    method: 'POST', body: JSON.stringify({ types }),
  }),

  // Queue
  getQueueStatus: () => request<any[]>('/process/queue'),

  // Outputs & Export
  listOutputs: (lectureId: string) => request<any>(`/outputs/${lectureId}`),
  exportLecture: (lectureId: string) => {
    window.open(`${API_BASE}/export/${lectureId}`, '_blank')
  },
  downloadOutput: (lectureId: string, outputType: string, format: 'md' | 'txt' = 'md') => {
    window.open(`${API_BASE}/export/${lectureId}/${outputType}/${format}`, '_blank')
  },

  // Stats
  getStats: () => request<any>('/stats'),

  // Settings
  getSettings: () => request<any>('/settings'),
  updateSettings: (data: any) => request('/settings', { method: 'PUT', body: JSON.stringify(data) }),
}
